<script lang="ts">
    import { tick } from "svelte"
    import Cta from "../../components/CTA.svelte"
    import SubField from "./SubField.svelte"
    import { copyObject } from "../utils"
    import { actionApproval } from "../../store"

    export let field: TaskStepField<"objectArray">,
        value: any[] = [{}],
        fullPath: string

    if (!Array.isArray(value)) value = [{}]

    function isEmptyOrFalsy(obj: any) {
        if (obj == null) return true
        if (typeof obj !== "object") return !obj
        return Object.values(obj).every(isEmptyOrFalsy)
    }

    let defaultEmptyObject = {}

    function updateValueArray() {
        let filteredValue = value

        filteredValue = value.filter((v, i) => !isEmptyOrFalsy(v))
        if (filteredValue.length !== value.length) {
            defaultEmptyObject = copyObject(value.filter((v, i) => isEmptyOrFalsy(v))[0])
        }

        if (isEmptyOrFalsy(value[value.length - 1]) && filteredValue.length == value.length - 1) return
        filteredValue = [...filteredValue, copyObject(defaultEmptyObject)]

        if (JSON.stringify(value) !== JSON.stringify(filteredValue)) {
            value = filteredValue
            saveFocus()
            rerender = !rerender
            tick().then(restoreFocus)
        }
    }

    let rerender = false
    let focusedElementId: string = null

    function saveFocus() {
        const focusedElement = document.activeElement
        if (focusedElement && focusedElement.id) {
            focusedElementId = focusedElement.id
        }
    }

    function restoreFocus() {
        if (focusedElementId) {
            setTimeout(() => {
                const elementToFocus = document.getElementById(focusedElementId)
                if (elementToFocus) {
                    elementToFocus.focus()
                }
            }, 0)
        }
    }

    $: updateValueArray(value)
</script>

<div class="object-array flex-direction-{field.flexDirection}">
    {#if field.label}
        <h3>{field.label}:</h3>
    {/if}
    <ul class="objects">
        {#key rerender}
            {#each value as val, i}
                <li>
                    <div class="nr">
                        {i + 1}.
                    </div>
                    <div class="grid-wrapper">
                        <div class="grid">
                            {#each field.subFields || [] as subField}
                                <div class="field {subField.size ? subField.size : 'col-12'} field-{subField.widget}">
                                    <SubField
                                        subField="{subField}"
                                        fullPath="{fullPath}.{i}."
                                        bind:value="{val}"
                                    />
                                </div>
                            {/each}
                        </div>
                    </div>
                    {#if i !== value.length - 1}
                        <div class="trash">
                            <Cta
                                type="tableButton"
                                icon="solar_trash-bin-trash-outline"
                                noHover="{true}"
                                on:click="{() => {
                                    $actionApproval = {
                                        modalTitle: 'Löschen',
                                        modalText: 'Möchten Sie dieses Objekt wirklich löschen?',
                                        callback: () => {
                                            value = value.filter((_, index) => index !== i)
                                            rerender = !rerender
                                        },
                                    }
                                }}"
                            />
                        </div>
                    {/if}
                </li>
            {/each}
        {/key}
    </ul>
</div>

<style lang="less">
    @import "../../../../assets/variables.less";
    .object-array {
        width: 100%;
        display: flex;
        flex-direction: column;
        gap: 0.6rem;
        h3 {
            color: var(--text-100);
            font-size: 0.8rem;
            font-weight: 400;
        }
        .objects {
            display: flex;
            flex-direction: column;
            gap: 0.3rem;
            @media @mobile {
                gap: 1.2rem;
            }
            li {
                display: flex;
                height: fit-content;
                min-height: 4.2rem;
                border-radius: 12px;
                border: 1px solid var(--grey-300);
                position: relative;
                .trash {
                    position: absolute;
                    top: -0.5rem;
                    right: -0.5rem;
                }
                .nr {
                    background: var(--grey-300);
                    display: flex;
                    border-radius: 12px 0px 0px 12px;
                    width: 5rem;
                    min-width: 5rem;

                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                    color: var(--white-100);
                    gap: 10px;
                }
                .grid-wrapper {
                    padding: 0.6rem;
                    height: 100%;
                    flex-grow: 1;
                    .grid {
                        height: 100%;
                        .field {
                            height: 100%;
                            overflow: visible;
                        }
                    }
                }
                @media @mobile {
                    flex-direction: column;

                    .nr {
                        width: 100%;
                        padding: 0.6rem 0px;
                        border-radius: 12px 12px 0px 0px;
                    }
                }
            }
        }
    }
</style>
